import {
  Routes as Switch,
  Route,
  Navigate,
  useNavigate,
  replace,
} from "react-router-dom";
import { useContext, useEffect } from "react";
import Home from "./Application/Home/Home";
import { AuthContext } from "./Provider/AuthContext";
import Login from "./Application/Login/Login";

//ID_TIPO 1
import SolicitacaoDeColeta from "./pages/SolicitacaoDeColeta/SolicitacaoDeColeta";
import ValidacaoDeColeta from "./pages/RotaUserLocal/ValidacaoDeColeta/ValidacaoDeColeta";
import ComprovanteDePagamento from "./pages/RotaUserLocal/ComprovanteDePagamento/ComprovanteDePagamento";
import AtualizarConta from "./pages/RotaUserLocal/AtualizarConta/AtualizarConta";
import RelatorioDeColeta from "./pages/RotaUserLocal/RelatorioDeColeta/RelatorioDeColeta";
import Certificado from "./pages/RotaUserLocal/Certificado/Certificado";
import GestaoDeLicenca from "./pages/GestaoDeLicenca/GestaoDeLicenca";
import NovaColeta from "./pages/RotaUserLocal/subPages/NovaColeta/NovaColeta";
import AcessoMtr from "./pages/RotaUserLocal/DropdownControleMTR/AcessoMTR";
import Cdf from "./pages/RotaUserLocal/DropdownControleMTR/CDF";
import MeusMtr from "./pages/RotaUserLocal/DropdownControleMTR/MeusMTR";

// ID_TIPO 3
import RelatorioDeColetaAdmin from "./pages/RotasAdmin/RelatorioDeColetaAdmin/RelatorioDeColetaAdmin";
import WellcomeAdmin from "./pages/RotasAdmin/Wellcome";

// ID_TIPO 4 || PREPOSTO 0
import RoteirosDisponiveis from "./pages/RotasMotorista/RoteirosDisponiveis";
import ListagemDeColetas from "./pages/RotasMotorista/ListagemDeColetas";
import DetalhesColeta from "./pages/RotasMotorista/DetalhesColeta";
import DetalhesColetaProdutos from "./pages/RotasMotorista/DetalhesColetaProdutos";
import ColetaNaoTemOleo from "./pages/RotasMotorista/DetalhesColetaNaoTemOleo";

// ID_TIPO 4 || PREPOSTO 1
import ListagemDeColetasPreposto from "./pages/Preposto/RotasMotorista/ListagemDeColetas";
import DetalhesColetaPreposto from "./pages/Preposto/RotasMotorista/DetalhesColeta";

import Roteiros from "./pages/Preposto/RotasMotorista/Roteiros";
import NovoRoteiro from "./pages/Preposto/RotasMotorista/NovoRoteiro";
// ID_TIPO 5
//Rota Principal
import WellcomeUsina from "./pages/RotasUsina/Wellcome";

//RELATORIO DE AGRUPAMENTO
import GrupoHome from "./pages/Grupo/Wellcome";
import GrupoCertificado from "./pages/Grupo/Certificado/Certificado";

//Links sem dropdown
import Usuarios from "./pages/RotasUsina/Usuarios";
import UsuariosAction from "./pages/RotasUsina/Usuarios/Action";
//Dropdown Cadastro
import Embaixador from "./pages/RotasUsina/Cadastro/Embaixador";
import EmbaixadorAction from "./pages/RotasUsina/Cadastro/Embaixador/Action";
import Prospect from "./pages/RotasUsina/Cadastro/Prospect";
import Local from "./pages/RotasUsina/Cadastro/Locais";
import TabsLocal from "./pages/RotasUsina/Cadastro/Locais/Tabs1";
// import TabsLocal from './pages/RotasUsina/Cadastro/Locais/Tabs/Action'
import Preposto from "./pages/RotasUsina/Cadastro/Preposto";
import PrepostoAction from "./pages/RotasUsina/Cadastro/Preposto/Action";
// import LocalAction from './pages/RotasUsina/Cadastro/Locais/Action'

//Dropdown Ligação
import PainelDeLigacao from "./pages/RotasUsina/Ligacao/PainelDeLigacao";
import DashLigacao from "./pages/RotasUsina/Ligacao/DashLigacao";

// Dropdow Coletas
import EmissaoDeColeta from "./pages/RotasUsina/Coletas/EmissaoDeColeta";
// import EmissaoDeColetaAdmin from './pages/RotasUsina/Coletas/EmissaoDeColeta/Action'
import TabsColeta from "./pages/RotasUsina/Coletas/EmissaoDeColeta/Tabs";

import Ocorrencia from "./pages/RotasUsina/Coletas/Ocorrencia";
import OcorrenciaAdmin from "./pages/RotasUsina/Coletas/Ocorrencia/Action";

//Dropdown Material
import Grupo from "./pages/RotasUsina/Tabelas/Grupo";
import GrupoAction from "./pages/RotasUsina/Tabelas/Grupo/Action";

import Material from "./pages/RotasUsina/Tabelas/Material";
import MaterialAction from "./pages/RotasUsina/Tabelas/Material/Action";

import Campanha from "./pages/RotasUsina/Tabelas/Campanha";
import CampanhaAction from "./pages/RotasUsina/Tabelas/Campanha/Action";

import Brinde from "./pages/RotasUsina/Tabelas/Brinde";
import BrindeAction from "./pages/RotasUsina/Tabelas/Brinde/Action";

import Bombona from "./pages/RotasUsina/Tabelas/Bombona";
import BombonaAction from "./pages/RotasUsina/Tabelas/Bombona/Action";

import Estabelecimento from "./pages/RotasUsina/Tabelas/Estabelecimento";
import EstabelecimentoAction from "./pages/RotasUsina/Tabelas/Estabelecimento/Action";

import PreferenciaContato from "./pages/RotasUsina/Tabelas/PreferenciaContato";
import PreferenciaContatoAction from "./pages/RotasUsina/Tabelas/PreferenciaContato/Action";

import CadastrarMotorista from "./pages/RotasUsina/Tabelas/Motorista";

import Cidade from "./pages/RotasUsina/Tabelas/Cidade";
import CidadeAction from "./pages/RotasUsina/Tabelas/Cidade/Action";

import TipoLogradouro from "./pages/RotasUsina/Tabelas/TipoLogradouro";
import TipoLogradouroAction from "./pages/RotasUsina/Tabelas/TipoLogradouro/Action";

import Veiculo from "./pages/RotasUsina/Tabelas/Veiculo";
import VeiculoAction from "./pages/RotasUsina/Tabelas/Veiculo/Action";

// Rota Generica
import AtualizarUsuario from "./pages/AtualizarUsuario/AtualizarUsuario";

import PainelAdm from "./pages/RotasAdmin/Painel/index";

import MotoristaRelatorioPagamento from "./pages/RotasMotorista/RelatorioPagamento/index";
import RotaValidatKm from "./pages/RotasMotorista/RoteiroValidarKm/index";

//ROTA LOGISTICA
import LogiPainel from "./pages/RotasUsina/Logistica/PainelLogistica";
import CriacaoRotaLogistica from "./pages/RotasUsina/Logistica/OrdemCarregamento";

//INDICADOR DIARIO
import IndicadorDiario from "./pages/RotasUsina/Relatorio/Indicador/Indicador";
//PLANEJAMENTO INDICADOR DIARIO
import PlanejamentoIndicadorDiario from "./pages/RotasUsina/Planejamento/Indicador/PlajementoIndicador";
//AUDITORIA MOTORISTA
import AuditoriaMotorista from "./pages/RotasUsina/Relatorio/AuditoriaMotorista/auditoriaMotorista";
//INDICADOR SEGMENTO
import IndicadorSegmento from "./pages/RotasUsina/Relatorio/IndicadorSegmento/indicadorSegmento";
import { isTokenExpired } from "./services/auth";
import PainelLogistica from "./pages/RotasUsina/Logistica/PainelLogistica";
import PrivateRoute from "./services/PrivateRoute";
import { toast } from "react-toastify";
import Acao from "./pages/RotasUsina/Tabelas/Acao";
import AcaoAction from "./pages/RotasUsina/Tabelas/Acao/Action";

import Perfil from "./pages/RotasUsina/Tabelas/Perfil";
import PerfilAction from "./pages/RotasUsina/Tabelas/Perfil/Action";
import RelatorioDeTotais from "./pages/RotasUsina/Pesagem/RelatorioDeTotais/RelatorioDeTotais";
import Unauthorized from "./components/Unauthorized/Unauthorized";
import Relatorios from "./pages/RotasUsina/Relatorio/Relatorios";
import AlterarValorFornecedor from "./pages/RotasUsina/GestaoOperacional/AlterarValorFornecedorEColeta/AlterarValorFornecedor";
import Certificados from "./pages/RotasUsina/Tabelas/Certificados/Certificados";
import PontosLocaisOrigem from "./pages/RotasUsina/Tabelas/PontosLocaisOrigem";
import PontosLocaisOrigemAction from "./pages/RotasUsina/Tabelas/PontosLocaisOrigem/Action";

export default function Routes() {
  const { idTipoUsuario, preposto, idDepartamento } = useContext(AuthContext);
  let path = "";
  console.log(`departamento router ${idDepartamento}`);
  // if (preposto === 0) {
  //   if (idTipoUsuario == 5 && idDepartamento == 9) {
  //     path = "/grupo";
  //   } else if (idTipoUsuario === 1) {
  //     path = "/home";
  //   } else if (idTipoUsuario === 3) {
  //     path = "/local";
  //   } else if (idTipoUsuario === 4) {
  //     path = "/local";
  //   } else if (idTipoUsuario === 5) {
  //     path = "/usina";
  //   }
  // }

  const idTipoMenu = localStorage.getItem("tipoMenu");

  if (preposto === 0) {
    if (idTipoMenu == 1) {
      path = "/local";
    } else if (idTipoMenu == 2) {
      path = "/usina";
    }
  }

  if (preposto === 1) {
    if (idTipoUsuario === 1) {
      path = "/prep/home/";
    }
    if (idTipoUsuario === 3) {
      path = "/prep/admin/";
    }
    if (idTipoUsuario === 4) {
      path = "/prep/motorista/";
    }
    if (idTipoUsuario === 5) {
      path = "/prep/usina/";
    }
  }

  let rotasUsuarioTipo1 = {};
  let rotasUsuarioTipo3 = {};
  let rotasUsuarioTipo4 = {};
  let rotasUsuarioTipo5 = {};
  let rotasUsuarioGrupo = {};

  let rotasMenuTipo1 = {};
  let rotasMenuTipo2 = {};
  // Valida rota pelo preposto
  // if (preposto === 0) {
  //   rotasUsuarioGrupo = [
  //     {
  //       component: <GrupoHome />,
  //       path: "",
  //     },
  //     {
  //       component: <GrupoCertificado />,
  //       path: "certificado",
  //     },

  //     {
  //       component: <GestaoDeLicenca />,
  //       path: "gestao-de-licenca",
  //     },
  //   ];

  //   rotasUsuarioTipo1 = [
  //     {
  //       component: <SolicitacaoDeColeta />,
  //       path: "",
  //     },
  //     // {
  //     //   component: <ValidacaoDeColeta />,
  //     //   path: 'validacao-de-coleta',
  //     // },
  //     {
  //       component: <ComprovanteDePagamento />,
  //       path: "comprovante-de-pagamento",
  //     },
  //     {
  //       component: <AtualizarConta />,
  //       path: "atualizar-conta",
  //     },
  //     {
  //       component: <RelatorioDeColeta />,
  //       path: "relatorio-de-coleta",
  //     },
  //     {
  //       component: <Certificado />,
  //       path: "certificado",
  //     },
  //     {
  //       component: <GestaoDeLicenca />,
  //       path: "gestao-de-licenca",
  //     },
  //     {
  //       component: <AtualizarUsuario />,
  //       path: "atualizar-usuario",
  //     },
  //     {
  //       component: <NovaColeta />,
  //       path: "nova-coleta",
  //     },
  //     {
  //       component: <AcessoMtr />,
  //       path: "acesso-mtr",
  //     },
  //     {
  //       component: <Cdf />,
  //       path: "cdf",
  //     },
  //     {
  //       component: <MeusMtr />,
  //       path: "meus-mtr",
  //     },
  //   ];
  //   rotasUsuarioTipo3 = [
  //     {
  //       component: <WellcomeAdmin />,
  //       path: "",
  //     },
  //     {
  //       component: <GestaoDeLicenca />,
  //       path: "gestao-de-licenca",
  //     },
  //     {
  //       component: <PainelAdm />,
  //       path: "painel",
  //     },
  //     {
  //       component: <RelatorioDeColetaAdmin />,
  //       path: "relatorio-de-coleta/",
  //     },
  //     {
  //       component: <AtualizarUsuario />,
  //       path: "atualizar-usuario",
  //     },
  //   ];
  //   rotasUsuarioTipo4 = [
  //     {
  //       component: <RoteirosDisponiveis />,
  //       path: "",
  //     },
  //     {
  //       component: <MotoristaRelatorioPagamento />,
  //       path: "relatoriopagamento",
  //     },
  //     {
  //       component: <ListagemDeColetas />,
  //       path: "listagem-de-coletas/:id",
  //     },
  //     {
  //       component: <DetalhesColeta />,
  //       path: "detalhe-coleta/:id",
  //     },
  //     {
  //       component: <DetalhesColetaProdutos />,
  //       path: "detalhe-coleta-produtos/:id",
  //     },
  //     {
  //       component: <ColetaNaoTemOleo />,
  //       path: "coleta-nao-tem-oleo/:id",
  //     },
  //     {
  //       component: <AtualizarUsuario />,
  //       path: "atualizar-usuario",
  //     },
  //     {
  //       component: <RotaValidatKm />,
  //       path: "validarkminicial",
  //     },
  //   ];
  //   rotasUsuarioTipo5 = [
  //     //Rota Principal
  //     {
  //       component: <WellcomeUsina />,
  //       path: "/usina",
  //     },
  //     //Links sem dropdowns
  //     {
  //       component: <Usuarios />,
  //       path: "usuarios",
  //     },
  //     {
  //       component: <UsuariosAction />,
  //       path: "usuarios/novo/",
  //     },
  //     {
  //       component: <UsuariosAction />,
  //       path: "usuarios/edit/:id",
  //     },
  //     //Dropdown Cadastro
  //     {
  //       component: <Embaixador />,
  //       path: "embaixador",
  //     },
  //     {
  //       component: <EmbaixadorAction />,
  //       path: "embaixador/novo/",
  //     },
  //     {
  //       component: <EmbaixadorAction />,
  //       path: "embaixador/edit/:id",
  //     },

  //     {
  //       component: <TabsLocal />,
  //       path: "action-painel/edit/:id",
  //     },
  //     {
  //       component: <TabsLocal />,
  //       path: "action-painel/",
  //     },
  //     {
  //       component: <Prospect />,
  //       path: "prospect",
  //     },
  //     {
  //       component: <Local />,
  //       path: "local",
  //     },
  //     {
  //       component: <Preposto />,
  //       path: "preposto",
  //     },
  //     {
  //       component: <PrepostoAction />,
  //       path: "preposto/novo",
  //     },
  //     {
  //       component: <PrepostoAction />,
  //       path: "preposto/edit/:id",
  //     },

  //     // {
  //     //   component: <LocalAction />,
  //     //   path: 'local/novo/',
  //     // },
  //     // {
  //     //   component: <LocalAction />,
  //     //   path: 'local/edit/:id',
  //     // },
  //     // Dropdow Ligação
  //     {
  //       component: <PainelDeLigacao />,
  //       path: "painel-de-ligacao",
  //     },
  //     {
  //       component: <DashLigacao />,
  //       path: "dash-ligacao",
  //     },
  //     // Dropdown Coletas
  //     {
  //       component: <EmissaoDeColeta />,
  //       path: "emissao-de-coleta",
  //     },
  //     // {
  //     //   component: <EmissaoDeColetaAdmin />,
  //     //   path: 'emissao-de-coleta/novo',
  //     // },
  //     // {
  //     //   component: <EmissaoDeColetaAdmin />,
  //     //   path: 'emissao-de-coleta/edit/:id',
  //     // },

  //     {
  //       component: <TabsColeta />,
  //       path: "action-painel-coleta/novo",
  //     },
  //     {
  //       component: <TabsColeta />,
  //       path: "action-painel-coleta/edit/:id",
  //     },

  //     {
  //       component: <LogiPainel />,
  //       path: "logistica/painel",
  //     },

  //     {
  //       component: <CriacaoRotaLogistica />,
  //       path: "logistica/criarota",
  //     },

  //     {
  //       component: <IndicadorDiario />,
  //       path: "relario/indicador",
  //     },
  //     {
  //       component: <IndicadorSegmento />,
  //       path: "relatorio/indicadorsegmento",
  //     },
  //     {
  //       component: <PlanejamentoIndicadorDiario />,
  //       path: "planejamento/indicador",
  //     },

  //     {
  //       component: <AuditoriaMotorista />,
  //       path: "relatorio/auditoriamotorista",
  //     },

  //     {
  //       component: <Ocorrencia />,
  //       path: "ocorrencia",
  //     },
  //     {
  //       component: <OcorrenciaAdmin />,
  //       path: "ocorrencia/novo",
  //     },
  //     {
  //       component: <OcorrenciaAdmin />,
  //       path: "ocorrencia/edit/:id",
  //     },

  //     // Dropdown Tabela
  //     {
  //       component: <Material />,
  //       path: "material",
  //     },
  //     {
  //       component: <MaterialAction />,
  //       path: "material/novo/",
  //     },
  //     {
  //       component: <MaterialAction />,
  //       path: "material/edit/:id",
  //     },
  //     {
  //       component: <Grupo />,
  //       path: "grupo",
  //     },
  //     {
  //       component: <GrupoAction />,
  //       path: "grupo/novo/",
  //     },
  //     {
  //       component: <GrupoAction />,
  //       path: "grupo/edit/:id",
  //     },
  //     {
  //       component: <Campanha />,
  //       path: "campanha/",
  //     },
  //     {
  //       component: <CampanhaAction />,
  //       path: "campanha/novo",
  //     },
  //     {
  //       component: <CampanhaAction />,
  //       path: "campanha/edit/:id",
  //     },
  //     {
  //       component: <Brinde />,
  //       path: "brinde/",
  //     },
  //     {
  //       component: <BrindeAction />,
  //       path: "brinde/novo",
  //     },
  //     {
  //       component: <BrindeAction />,
  //       path: "brinde/edit/:id",
  //     },
  //     {
  //       component: <Bombona />,
  //       path: "bombona/",
  //     },
  //     {
  //       component: <BombonaAction />,
  //       path: "bombona/novo/",
  //     },
  //     {
  //       component: <BombonaAction />,
  //       path: "bombona/edit/:id",
  //     },
  //     {
  //       component: <AtualizarUsuario />,
  //       path: "atualizar-usuario",
  //     },

  //     {
  //       component: <CadastrarMotorista />,
  //       path: "cadastrar-motorista",
  //     },

  //     {
  //       component: <Estabelecimento />,
  //       path: "estabelecimento",
  //     },
  //     {
  //       component: <EstabelecimentoAction />,
  //       path: "estabelecimento/novo",
  //     },
  //     {
  //       component: <EstabelecimentoAction />,
  //       path: "estabelecimento/edit/:id",
  //     },

  //     {
  //       component: <Acao />,
  //       path: "acao",
  //     },
  //     {
  //       component: <AcaoAction />,
  //       path: "acao/novo",
  //     },
  //     {
  //       component: <AcaoAction />,
  //       path: "acao/edit/:id",
  //     },

  //     {
  //       component: <Perfil />,
  //       path: "perfil",
  //     },
  //     {
  //       component: <PerfilAction />,
  //       path: "perfil/novo",
  //     },
  //     {
  //       component: <PerfilAction />,
  //       path: "perfil/edit/:id",
  //     },

  //     {
  //       component: <Cidade />,
  //       path: "cidade",
  //     },
  //     {
  //       component: <CidadeAction />,
  //       path: "cidade/novo",
  //     },
  //     {
  //       component: <CidadeAction />,
  //       path: "cidade/edit/:id",
  //     },
  //     {
  //       component: <PreferenciaContato />,
  //       path: "preferencia-contato",
  //     },
  //     {
  //       component: <PreferenciaContatoAction />,
  //       path: "preferencia-contato/novo",
  //     },
  //     {
  //       component: <PreferenciaContatoAction />,
  //       path: "preferencia-contato/edit/:id",
  //     },
  //     {
  //       component: <TipoLogradouro />,
  //       path: "tipo-logradouro",
  //     },
  //     {
  //       component: <TipoLogradouroAction />,
  //       path: "tipo-logradouro/novo",
  //     },
  //     {
  //       component: <TipoLogradouroAction />,
  //       path: "tipo-logradouro/edit/:id",
  //     },

  //     {
  //       component: <Veiculo />,
  //       path: "veiculo",
  //     },
  //     {
  //       component: <VeiculoAction />,
  //       path: "veiculo/novo",
  //     },
  //     {
  //       component: <VeiculoAction />,
  //       path: "veiculo/edit/:id",
  //     },
  //   ];
  // }
  if (preposto === 0) {
    rotasMenuTipo1 = [
      {
        component: <GrupoHome />,
        path: "",
      },
      {
        component: <GrupoCertificado />,
        path: "certificado",
      },

      {
        component: <GestaoDeLicenca />,
        path: "gestao-de-licenca",
      },
      {
        component: <SolicitacaoDeColeta />,
        path: "",
      },
      // {
      //   component: <ValidacaoDeColeta />,
      //   path: 'validacao-de-coleta',
      // },
      {
        component: <ComprovanteDePagamento />,
        path: "comprovante-de-pagamento",
      },
      {
        component: <AtualizarConta />,
        path: "atualizar-conta",
      },
      {
        component: <RelatorioDeColeta />,
        path: "relatorio-de-coleta",
      },
      {
        component: <Certificado />,
        path: "certificado",
      },
      {
        component: <GestaoDeLicenca />,
        path: "gestao-de-licenca",
      },
      {
        component: <AtualizarUsuario />,
        path: "atualizar-usuario",
      },
      {
        component: <NovaColeta />,
        path: "nova-coleta",
      },
      {
        component: <AcessoMtr />,
        path: "acesso-mtr",
      },
      {
        component: <Cdf />,
        path: "cdf",
      },
      {
        component: <MeusMtr />,
        path: "meus-mtr",
      },
      {
        component: <WellcomeAdmin />,
        path: "",
      },
      {
        component: <GestaoDeLicenca />,
        path: "gestao-de-licenca",
      },
      {
        component: <PainelAdm />,
        path: "painel",
      },
      {
        component: <RelatorioDeColetaAdmin />,
        path: "relatorio-de-coleta/",
      },
      {
        component: <AtualizarUsuario />,
        path: "atualizar-usuario",
      },
      {
        component: <RoteirosDisponiveis />,
        path: "freguesias",
      },
      {
        component: <MotoristaRelatorioPagamento />,
        path: "relatoriopagamento",
      },
      {
        component: <ListagemDeColetas />,
        path: "listagem-de-coletas/:id",
      },
      {
        component: <DetalhesColeta />,
        path: "detalhe-coleta/:id",
      },
      {
        component: <DetalhesColetaProdutos />,
        path: "detalhe-coleta-produtos/:id",
      },
      {
        component: <ColetaNaoTemOleo />,
        path: "coleta-nao-tem-oleo/:id",
      },
      {
        component: <AtualizarUsuario />,
        path: "atualizar-usuario",
      },
      {
        component: <RotaValidatKm />,
        path: "validarkminicial",
      },
    ];

    rotasMenuTipo2 = [
      //Rota Principal
      {
        component: <WellcomeUsina />,
        path: "",
      },
      //Links sem dropdowns
      {
        component: <Usuarios />,
        path: "usuarios",
      },
      {
        component: <UsuariosAction />,
        path: "usuarios/novo/",
      },
      {
        component: <UsuariosAction />,
        path: "usuarios/edit/:id",
      },
      //Dropdown Cadastro
      {
        component: <Embaixador />,
        path: "embaixador",
      },
      {
        component: <EmbaixadorAction />,
        path: "embaixador/novo/",
      },
      {
        component: <EmbaixadorAction />,
        path: "embaixador/edit/:id",
      },

      {
        component: <TabsLocal />,
        path: "action-painel/edit/:id",
      },
      {
        component: <TabsLocal />,
        path: "action-painel/",
      },
      {
        component: <Prospect />,
        path: "prospect",
      },
      {
        component: <Local />,
        path: "local",
      },
      {
        component: <Preposto />,
        path: "preposto",
      },
      {
        component: <PrepostoAction />,
        path: "preposto/novo",
      },
      {
        component: <PrepostoAction />,
        path: "preposto/edit/:id",
      },

      // {
      //   component: <LocalAction />,
      //   path: 'local/novo/',
      // },
      // {
      //   component: <LocalAction />,
      //   path: 'local/edit/:id',
      // },
      // Dropdow Ligação
      {
        component: <PainelDeLigacao />,
        path: "painel-de-ligacao",
      },
      {
        component: <DashLigacao />,
        path: "dash-ligacao",
      },
      // Dropdown Coletas
      {
        component: <EmissaoDeColeta />,
        path: "emissao-de-coleta",
      },
      // {
      //   component: <EmissaoDeColetaAdmin />,
      //   path: 'emissao-de-coleta/novo',
      // },
      // {
      //   component: <EmissaoDeColetaAdmin />,
      //   path: 'emissao-de-coleta/edit/:id',
      // },

      {
        component: <TabsColeta />,
        path: "action-painel-coleta/novo",
      },
      {
        component: <TabsColeta />,
        path: "action-painel-coleta/edit/:id",
      },

      {
        component: <LogiPainel />,
        path: "logistica/painel",
      },

      {
        component: <CriacaoRotaLogistica />,
        path: "logistica/criarota",
      },
      {
        component: <Relatorios />,
        path: "relatorios",
      },
      {
        component: <IndicadorDiario />,
        path: "relario/indicador",
      },
      {
        component: <IndicadorSegmento />,
        path: "relatorio/indicadorsegmento",
      },
      {
        component: <PlanejamentoIndicadorDiario />,
        path: "planejamento/indicador",
      },

      {
        component: <AuditoriaMotorista />,
        path: "relatorio/auditoriamotorista",
      },

      {
        component: <Ocorrencia />,
        path: "ocorrencia",
      },
      {
        component: <OcorrenciaAdmin />,
        path: "ocorrencia/novo",
      },
      {
        component: <OcorrenciaAdmin />,
        path: "ocorrencia/edit/:id",
      },

      // Dropdown Tabela
      {
        component: <Material />,
        path: "material",
      },
      {
        component: <MaterialAction />,
        path: "material/novo/",
      },
      {
        component: <MaterialAction />,
        path: "material/edit/:id",
      },
      {
        component: <Grupo />,
        path: "grupo",
      },
      {
        component: <GrupoAction />,
        path: "grupo/novo/",
      },
      {
        component: <GrupoAction />,
        path: "grupo/edit/:id",
      },
      {
        component: <Campanha />,
        path: "campanha/",
      },
      {
        component: <CampanhaAction />,
        path: "campanha/novo",
      },
      {
        component: <CampanhaAction />,
        path: "campanha/edit/:id",
      },
      {
        component: <Brinde />,
        path: "brinde/",
      },
      {
        component: <BrindeAction />,
        path: "brinde/novo",
      },
      {
        component: <BrindeAction />,
        path: "brinde/edit/:id",
      },
      {
        component: <PontosLocaisOrigem />,
        path: "pontoslocaisorigem/",
      },
      {
        component: <PontosLocaisOrigemAction />,
        path: "pontoslocaisorigem/novo",
      },
      {
        component: <PontosLocaisOrigemAction />,
        path: "pontoslocaisorigem/edit/:id",
      },
      {
        component: <Bombona />,
        path: "bombona/",
      },
      {
        component: <BombonaAction />,
        path: "bombona/novo/",
      },
      {
        component: <BombonaAction />,
        path: "bombona/edit/:id",
      },
      {
        component: <AtualizarUsuario />,
        path: "atualizar-usuario",
      },

      {
        component: <CadastrarMotorista />,
        path: "cadastrar-motorista",
      },

      {
        component: <Estabelecimento />,
        path: "estabelecimento",
      },
      {
        component: <EstabelecimentoAction />,
        path: "estabelecimento/novo",
      },
      {
        component: <EstabelecimentoAction />,
        path: "estabelecimento/edit/:id",
      },

      {
        component: <Acao />,
        path: "acao",
      },
      {
        component: <AcaoAction />,
        path: "acao/novo",
      },
      {
        component: <AcaoAction />,
        path: "acao/edit/:id",
      },

      {
        component: <Perfil />,
        path: "perfil",
      },
      {
        component: <PerfilAction />,
        path: "perfil/novo",
      },
      {
        component: <PerfilAction />,
        path: "perfil/edit/:id",
      },

      {
        component: <Cidade />,
        path: "cidade",
      },
      {
        component: <CidadeAction />,
        path: "cidade/novo",
      },
      {
        component: <CidadeAction />,
        path: "cidade/edit/:id",
      },
      {
        component: <PreferenciaContato />,
        path: "preferencia-contato",
      },
      {
        component: <PreferenciaContatoAction />,
        path: "preferencia-contato/novo",
      },
      {
        component: <PreferenciaContatoAction />,
        path: "preferencia-contato/edit/:id",
      },
      {
        component: <TipoLogradouro />,
        path: "tipo-logradouro",
      },
      {
        component: <TipoLogradouroAction />,
        path: "tipo-logradouro/novo",
      },
      {
        component: <TipoLogradouroAction />,
        path: "tipo-logradouro/edit/:id",
      },

      {
        component: <Veiculo />,
        path: "veiculo",
      },
      {
        component: <VeiculoAction />,
        path: "veiculo/novo",
      },
      {
        component: <VeiculoAction />,
        path: "veiculo/edit/:id",
      },
      {
        component: <RelatorioDeTotais />,
        path: "relatorio-de-totais",
      },
      {
        component: <AlterarValorFornecedor />,
        path: "alterar-valor-fornecedor",
      },
      {
        component: <Certificados />,
        path: "certificados",
      },
    ];
  }
  if (preposto === 1) {
    rotasUsuarioTipo4 = [
      {
        component: <ListagemDeColetasPreposto />,
        path: "/prep/local",
      },
      {
        component: <DetalhesColetaPreposto />,
        path: "/prep/local/detalhe-coleta/:id",
      },
      {
        component: <Roteiros />,
        path: "/prep/local/roteiros",
      },
      {
        component: <NovoRoteiro />,
        path: "/prep/local/novo-roteiro",
      },
    ];
  }
  // Validação de rota
  let rotaUsuario = [];

  // if (idTipoUsuario === 5 && idDepartamento == 9) {
  //   rotaUsuario = rotasUsuarioGrupo;
  // } else if (idTipoUsuario === 1) {
  //   rotaUsuario = rotasUsuarioTipo1;
  // } else if (idTipoUsuario === 3) {
  //   rotaUsuario = rotasUsuarioTipo3;
  // } else if (idTipoUsuario === 4) {
  //   rotaUsuario = rotasUsuarioTipo4;
  // } else if (idTipoUsuario === 5) {
  //   rotaUsuario = rotasUsuarioTipo5;
  // }

  if (idTipoMenu == 1) {
    rotaUsuario = rotasMenuTipo1;
  } else if (idTipoMenu == 2) {
    rotaUsuario = rotasMenuTipo2;
  }

  const navigate = useNavigate();
  const isExpired = isTokenExpired();

  useEffect(() => {
    if (isExpired) {
      navigate("/", { replace: true });
    }
  }, [navigate, isExpired]);

  if (isExpired) {
    return <Login />;
  }

  return (
    <Switch>
      <Route path="/" element={<Login />} />
      <Route path={path} element={<Home />}>
        {rotaUsuario?.map((values, index) => (
          <Route key={index} path={values?.path} element={values?.component} />
        ))}
        <Route path="unauthorized" element={<Unauthorized />} />
      </Route>
    </Switch>
  );
}
